require("./bootstrap");

// Alpine JS
import Alpine from "alpinejs";
import Lenis from "@studio-freight/lenis";

import "./parallax-images";
import "./intersection";

window.Alpine = Alpine;
Alpine.start();

const lenis = new Lenis();

function raf (time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}

requestAnimationFrame(raf);

// const callback = function (entries) {
//   entries.forEach((entry) => {
//     let animation = entry.target.dataset.animation
//
//     if (entry.isIntersecting) {
//
//       entry.target.classList.remove('opacity-0', '-translate-x-4')
//
//       //console.log(entry)
//
//       //scrollPosition(entry)
//     } else {
//       entry.target.classList.add('opacity-0', '-translate-x-4')
//     }
//   })
// }
//
// const observer = new IntersectionObserver(callback)
//
// const targets = document.querySelectorAll('.scroll-animation')
// targets.forEach(function (target) {
//   observer.observe(target)
// })

// const scrollPosition = function (entry) {
//   let innerHeight = window.innerHeight
//   let maxScroll = 20
//   let maxScrollArea = Math.round(innerHeight / 10)
//
//   document.addEventListener('scroll', function (e) {
//     let viewportOffset = entry.target.getBoundingClientRect()
//
//     //console.log(innerHeight - maxScrollArea)
//
//     if (
//       viewportOffset.top > innerHeight - maxScrollArea &&
//       viewportOffset.top < innerHeight
//     ) {
//       let animationStep =
//         (maxScroll / maxScrollArea) *
//         (viewportOffset.top - (innerHeight - maxScrollArea))
//
//       entry.target.style.transform = `translate3d(0, ${animationStep}px, 0)`
//     }
//   })
// }
